<!-- ============================================================== -->
<!-- Topbar header - style you can find in pages.scss -->
<!-- ============================================================== -->
<header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <!-- ============================================================== -->
        <!-- Logo -->
        <!-- ============================================================== -->
        <div class="navbar-header"></div>
        <div class="navbar-header position-fixed">
            <a class="navbar-brand">
                <!-- Logo icon --><b>
              <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
              <!-- Dark Logo icon -->
              <img src="../assets/images/LogoSm840x60.png" alt="homepage" class="dark-logo" />
              <!-- Light Logo icon -->
              <img src="../assets/images/LogoSm840x60.png" alt="homepage" class="light-logo" />
            </b>
                <!--End Logo icon -->
                <!-- Logo text <span>
                    dark Logo text 
                    <img src="../assets/images/logo-text.png" alt="homepage" class="dark-logo" />
                    Light Logo text -->
                <!--  <img src="../assets/images/logo-text.png" class="light-logo" alt="homepage" /></span> -->
            </a>
            <input id="prodId" name="prodId" type="hidden">
        </div>
        <!-- ============================================================== -->
        <!-- End Logo -->
        <!-- ============================================================== -->
        <div class="navbar-collapse">
            <!-- ============================================================== -->
            <!-- toggle and nav items -->
            <!-- ============================================================== -->
            <ul class="navbar-nav mr-auto mt-md-0">
                <!--
                <li class="nav-item"> <a class="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="mdi mdi-menu"></i></a> </li>
                <li class="nav-item m-l-10"> <a class="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>
                -->
                <!-- ============================================================== -->
                <!-- Comment -->
                <!-- ============================================================== -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="getNotifica()">
                            Notificaciones &nbsp; <i class="mdi mdi-bell-ring"></i><div *ngIf="hayNotificacion" class="notify"> <span class="heartbit"></span> <span class="point"></span><span class="nNotis">({{banderaNoti}})</span> </div>
                    </a>
                    <div class="dropdown-menu mailbox animated slideInUp">
                        <ul>
                            <li>
                                <div class="drop-title">Notificaciones <i *ngIf="estado" class="fa fa-spinner fa-pulse fa-fw"></i> </div>
                            </li>
                            <li>
                                <div class="message-center">
                                    <li *ngFor="let elementoMenu of notificacionesArray">
                                        <a *ngIf="elementoMenu.iconVisto === 'NOLEIDO'; else noOpaco" style="background-color:rgb(247, 238, 162);" (click)="goToUrl2(elementoMenu.url)" (click)="setEstatus(elementoMenu.id)" routerLink="/protected">
                                            <i class="mdi mdi-account-plus text-success"></i>
                                            <div>
                                                <font color="#e33c22">El usuario</font>
                                                <font color="#1c2825">{{elementoMenu.user}}</font>
                                                <font color="#e33c22">{{elementoMenu.mensaje}}</font>
                                                <font color="#1c2825"> {{elementoMenu.sucursalNombre}}</font>
                                                <br>
                                                <p>
                                                    <font size="1" color="#1c2825" id="icon"> ago aprox {{elementoMenu.tiempo}}</font> <i class="mdi mdi-bell-ring text-success" size="10"></i>
                                                </p>
                                            </div>
                                        </a>
                                        <ng-template #noOpaco>
                                            <a routerLink="/protected" (click)="goToUrl(elementoMenu.url)">
                                                <i class="mdi mdi-account-plus text-success"></i>
                                                <div>
                                                    <font color="#e33c22">El usuario</font>
                                                    <font color="#1c2825">{{elementoMenu.user}}</font>
                                                    <font color="#e33c22">{{elementoMenu.mensaje}}</font>
                                                    <font color="#1c2825"> {{elementoMenu.sucursalNombre}}</font>
                                                    <br>
                                                    <p>
                                                        <font size="1" color="#1c2825" id="icon"> ago aprox <span class="time">{{elementoMenu.tiempo}}</span></font> <i class="mdi mdi-bell-outline text-success" size="10"></i>
                                                    </p>
                                                </div>
                                            </a>
                                        </ng-template>
                                    </li>
                                </div>
                            </li>
                            <li>
                                <a class="nav-link text-center" routerLink="/dashboard/notificaciones"> <strong>Revisar todas las notificaciones</strong> <i class="fa fa-angle-right"></i> </a>
                            </li>
                        </ul>
                    </div>
                </li>
                <!-- ======================================== -->
                <!-- ========== Sistema de Tickets ========== -->
                <!-- ======================================== -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark" aria-haspopup="true" aria-expanded="false" routerLink="/dashboard/tickets/0">
                        <i class="mdi mdi-tumblr"> &nbsp; tickets (soporte Tecnico) </i>
                    </a>
                </li>
                <!-- ======================================== -->
                <!-- ========== Sistema de Tickets ========== -->
                <!-- ======================================== -->
                <!-- ==================================== -->
                <!-- ========== Página de SMM8 ========== -->
                <!-- ==================================== -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark" aria-haspopup="true" aria-expanded="false" href="http://www.sm8.com.mx/" target="_blank">
                        <i class="mdi mdi-home"> Página SM8</i>
                    </a>
                </li>
                <!-- ==================================== -->
                <!-- ========== Página de SMM8 ========== -->
                <!-- ==================================== -->
                <!-- ============= dropdown-toggle ================================================= -->
                <!-- End Comment -->
                <!-- ============================================================== -->
                <!-- ============================================================== -->
                <!-- Messages/Chat -->
                <!-- ============================================================== -->

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" id="2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> Chat  &nbsp; <i class="mdi mdi-comment-processing" (click)="getRooms()"></i>&nbsp;
                      <div *ngIf="hayMensaje" class="notify"> <span class="heartbit"></span> <span class="point"></span><span class="nNotis">{{cuantosMensajes}}</span> </div>
                    </a>
                    <div class="dropdown-menu mailbox animated slideInUp" aria-labelledby="2">
                        <ul>
                            <li>
                                <div class="drop-title">Chat SM8 </div><div><input class="form-control" style="width:80%; margin: 5px" type="text" name="busquedaChat" [(ngModel)]="busquedaChatText" (ngModelChange)="busquedaChat()"><i style="font-size: 35px" class="mdi mdi-account-search"></i> </div>
                            </li>
                            <li>
                                <div  id="divContenedorChats" class="message-center">
                                    <div *ngFor="let usuario of usuariosFiltrados">
                                    <a *ngIf="usuario.nMensajes !== 0; else sinM" style="background-color: azure;" data-toggle="modal" href="#chatPopUp" (click)="objetivoChatInicializar(usuario.username)" >
                                        <div class="user-img"> <img src="{{usuario.imagen}}" alt="user" class="img-circle"> <span *ngIf="usuario.enLinea; else offline" class="profile-status online pull-right"></span> <ng-template #offline><span class="profile-status offline pull-right"></span></ng-template>
                                        </div>
                                        <div class="mail-contnet">
                                            <h5>{{usuario.nombre}} &nbsp; <span *ngIf="usuario.nMensajes !== 0"> ({{usuario.nMensajes}})</span></h5> <span class="mail-desc">{{usuario.puesto}}</span> <span class="time">{{usuario.sucursal}}</span> </div>
                                    </a>
                                    <ng-template #sinM>
                                            <a data-toggle="modal" href="#chatPopUp" (click)="objetivoChatInicializar(usuario.username)" >
                                                    <div class="user-img"> <img src="{{usuario.imagen}}" alt="user" class="img-circle"> <span *ngIf="usuario.enLinea; else offline" class="profile-status online pull-right"></span> <ng-template #offline><span class="profile-status offline pull-right"></span></ng-template>
                                                    </div>
                                                    <div class="mail-contnet">
                                                        <h5>{{usuario.nombre}} &nbsp; <span *ngIf="usuario.nMensajes !== 0"> ({{usuario.nMensajes}})</span></h5> <span class="mail-desc">{{usuario.puesto}}</span> <span class="time">{{usuario.sucursal}}</span> </div>
                                                </a>
                                    </ng-template>
                                    
                                </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>

                <!-- ============================================================== -->
                <!-- End Messages/Chat -->
                <!-- ============================================================== -->
                <!-- ============================================================== -->
                <!-- Mensajes Globales -->
                <!-- ============================================================== -->
                <li *ngIf="usuario.rol === 'SISTEMAS'" class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle waves-effect waves-dark" aria-haspopup="true" aria-expanded="false" href="#" data-toggle="modal" href="#mensajesGlobales">
                      <i class="mdi mdi-earth">Mensajes Globlales</i>
                  </a>
                </li>
                <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle waves-effect waves-dark" aria-haspopup="true" routerLink="/dashboard/ayuda">
                                <i class="mdi mdi-help-circle">Ayuda</i>
                            </a>
                </li>
                <!-- ============================================================== -->
                <!-- Mensajes Globales -->
                <!-- ============================================================== -->

                <!-- ============================================================== -->
                <!-- Messages -->
                <!-- ============================================================== -->
                <!--
                      <li class="nav-item dropdown mega-dropdown"> <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="mdi mdi-view-grid"></i></a>
                        <div class="dropdown-menu animated slideInUp">
                          <ul class="mega-dropdown-menu row">
                            <li class="col-lg-3 col-xlg-2 m-b-30">
                              <h4 class="m-b-20">CAROUSEL</h4>
                               CAROUSEL 
                              <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                                <div class="carousel-inner" role="listbox">
                                  <div class="carousel-item active">
                                    <div class="container"> <img class="d-block img-fluid" src="../assets/images/big/img1.jpg" alt="First slide"></div>
                                  </div>
                                  <div class="carousel-item">
                                    <div class="container"><img class="d-block img-fluid" src="../assets/images/big/img2.jpg" alt="Second slide"></div>
                                  </div>
                                  <div class="carousel-item">
                                    <div class="container"><img class="d-block img-fluid" src="../assets/images/big/img3.jpg" alt="Third slide"></div>
                                  </div>
                                </div>
                                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev"> <span class="carousel-control-prev-icon" aria-hidden="true"></span> <span class="sr-only">Previous</span> </a>
                                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next"> <span class="carousel-control-next-icon" aria-hidden="true"></span> <span class="sr-only">Next</span> </a>
                              </div>
                               End CAROUSEL 
                            </li>
                            <li class="col-lg-3 m-b-30">
                              <h4 class="m-b-20">ACCORDION</h4>
                               Accordian 
                              <div id="accordion" class="nav-accordion" role="tablist" aria-multiselectable="true">
                                <div class="card">
                                  <div class="card-header" role="tab" id="headingOne">
                                    <h5 class="mb-0">
                                      <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Collapsible Group Item #1
                                      </a>
                                    </h5> </div>
                                  <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                                    <div class="card-body"> Anim pariatur cliche reprehenderit, enim eiusmod high. </div>
                                  </div>
                                </div>
                                <div class="card">
                                  <div class="card-header" role="tab" id="headingTwo">
                                    <h5 class="mb-0">
                                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Collapsible Group Item #2
                                      </a>
                                    </h5> </div>
                                  <div id="collapseTwo" class="collapse" role="tabpanel" aria-labelledby="headingTwo">
                                    <div class="card-body"> Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. </div>
                                  </div>
                                </div>
                                <div class="card">
                                  <div class="card-header" role="tab" id="headingThree">
                                    <h5 class="mb-0">
                                      <a class="collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        Collapsible Group Item #3
                                      </a>
                                    </h5> </div>
                                  <div id="collapseThree" class="collapse" role="tabpanel" aria-labelledby="headingThree">
                                    <div class="card-body"> Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li class="col-lg-3  m-b-30">
                              <h4 class="m-b-20">CONTACT US</h4>
                               Contact 
                              <form>
                                <div class="form-group">
                                  <input type="text" class="form-control" id="exampleInputname1" placeholder="Enter Name"> </div>
                                <div class="form-group">
                                  <input type="email" class="form-control" placeholder="Enter email"> </div>
                                <div class="form-group">
                                  <textarea class="form-control" id="exampleTextarea" rows="3" placeholder="Message"></textarea>
                                </div>
                                <button type="submit" class="btn btn-info">Submit</button>
                              </form>
                            </li>
                            <li class="col-lg-3 col-xlg-4 m-b-30">
                              <h4 class="m-b-20">List style</h4>
                              List style 
                              <ul class="list-style-none">
                                <li><a href="javascript:void(0)"><i class="fa fa-check text-success"></i> You can give link</a></li>
                                <li><a href="javascript:void(0)"><i class="fa fa-check text-success"></i> Give link</a></li>
                                <li><a href="javascript:void(0)"><i class="fa fa-check text-success"></i> Another Give link</a></li>
                                <li><a href="javascript:void(0)"><i class="fa fa-check text-success"></i> Forth link</a></li>
                                <li><a href="javascript:void(0)"><i class="fa fa-check text-success"></i> Another fifth link</a></li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </li>
                    -->
                <!-- ============================================================== -->
                <!-- End Messages -->
                <!-- ============================================================== -->
            </ul>
            <!--<ul>
                <i style="font-size: 20px" class="mdi mdi-monitor float-left waves-effect waves-dark dropdown-toggle direccionales" VALUE="regresar" (click)="capturaP()"><font style="font-size: 15px "> Captura de Pantalla</font></i>
            </ul>
            -->
            <!-- ============================================================== -->
            <!-- User profile and search -->
            <!-- ============================================================== -->
            <ul>
                <i style="font-size: 30px" class="mdi mdi-arrow-left-bold-circle-outline float-left waves-effect waves-dark dropdown-toggle direccionales" VALUE="regresar" onClick="history.go(-1)"></i>
                <i style="font-size: 30px" class="mdi mdi-arrow-right-bold-circle-outline float-left waves-effect waves-dark direccionales" VALUE="ir" onClick="history.go(1)"></i>
            </ul>
            <ul class="navbar-nav my-lg-0">
                <!-- ============================================================== -->
                <!-- Search -->
                <!-- ============================================================== -->
                <!-- <li class="nav-item hidden-sm-down search-box"> <a class="nav-link hidden-sm-down text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="ti-search"></i></a>
                        <form class="app-search">
                          <input type="text" class="form-control" placeholder="Search & enter"> <a class="srh-btn"><i class="ti-close"></i></a> </form>
                      </li>-->
                <!-- ============================================================== -->
                <!-- Profile -->
                <!-- ============================================================== -->
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><img src="{{usuario.imagenPerfil}}" alt="user" class="profile-pic" (click)="getUser()" /></a>
                    <div class="dropdown-menu dropdown-menu-right scale-up">
                        <ul class="dropdown-user">
                            <li>
                                <div class="dw-user-box">
                                    <div *ngIf="usuario" class="u-img"><img src="{{usuario.imagenPerfil}}" alt="user"></div>
                                    <div class="u-text">
                                        <h4>{{ usuario.nombre }} {{ usuario.apellido }}</h4>
                                        <p class="text-muted">{{ usuario.sucNombre }}</p>
                                        <a href="pages-profile.html" class="btn btn-rounded btn-danger btn-sm">{{ GENERALES.verPerfil }}</a>
                                    </div>
                                </div>
                            </li>
                            <li role="separator" class="divider"></li>
                            <!--<li><a href="#"><i class="ti-user"></i> My Profile</a></li>
                            <li><a href="#"><i class="ti-wallet"></i> My Balance</a></li>
                            <li><a href="#"><i class="ti-email"></i> Inbox</a></li>-->
                            <!--<li role="separator" class="divider"></li>
                            <li><a href="#"><i class="ti-settings"></i> Account Setting</a></li>
                            <li role="separator" class="divider"></li>-->
                            <li><a href="javascript:void()" (click)="logOut()"><i class="fa fa-power-off"></i> {{ GENERALES.logOut }}</a></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</header>
<!-- ============================================================== -->
<!-- End Topbar header -->
<!-- ============================================================== -->


<div class="modal fade" id="mensajesGlobales" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title">Mensajes Globales</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <div class="panel-body">
                  <div id="mensaje">
                    {{mensajeGlobalText}}
                  </div>
              </div>
          </div>
          <div class="modal-footer">
              <form (ngSubmit)="mensajeGlobal()">
                  <input id="textMensajeGlobal" type="text" />
                  <button type="submit" class="btn btn-info btn-circle btn-lg"><i class="fa fa-paper-plane-o"></i></button>
              </form>
          </div>
      </div>
  </div>
</div>
<div *ngIf="existeChat" class="container">
    	
	<div class="row">
	    <div class="chatbox chatbox22 chatbox--tray">
    <div class="chatbox__title" *ngIf="sala.enLinea; else noLinea">
        <h5><a href="javascript:void()">{{sala.username}} &nbsp;  (En linea) &nbsp;<font class="parpadea text">{{escribeChat}}</font></a></h5>
        <!--<button class="chatbox__title__tray">
            <span></span>
        </button>-->
        <button class="chatbox__title__close" (click)="closeChat()">
            <span>
                <svg viewBox="0 0 12 12" width="12px" height="12px">
                    <line stroke="#FFFFFF" x1="11.75" y1="0.25" x2="0.25" y2="11.75"></line>
                    <line stroke="#FFFFFF" x1="11.75" y1="11.75" x2="0.25" y2="0.25"></line>
                </svg>
            </span>
        </button>
    </div>
    <ng-template #noLinea>
        <div class="chatbox__title2">
            <h5><a href="javascript:void()">{{sala.username}}&nbsp; (Desconectado)&nbsp; <font class="parpadea text">{{escribeChat}}</font></a></h5>
            <!--<button class="chatbox__title__tray">
                <span></span>
            </button>-->
            <button class="chatbox__title__close" (click)="closeChat()">
                <span>
                    <svg viewBox="0 0 12 12" width="12px" height="12px">
                        <line stroke="#FFFFFF" x1="11.75" y1="0.25" x2="0.25" y2="11.75"></line>
                        <line stroke="#FFFFFF" x1="11.75" y1="11.75" x2="0.25" y2="0.25"></line>
                    </svg>
                </span>
            </button>
        </div>
    </ng-template>
    
    <div class="chatbox__body">
        <div *ngFor="let chat of chatTarget">
        <div *ngIf="chat.emisor !== usuario.userName; else noYoChat" class="chatbox__body__message chatbox__body__message--left">
		
		<div class="chatbox_timing">
		<ul>
		<li><a href="#"><i class="fa fa-calendar"></i> {{chat.fecha}}</a></li>
			<li><a href="#"><i class="fa fa-clock-o"></i> {{chat.hora}}</a></li>
		</ul>
		</div>
            <img src="{{chat.imagen}}" alt="Picture">
			<div class="clearfix"></div>
			<div class="ul_section_full">
			<ul class="ul_msg">
			<li><strong>{{chat.emisor}}</strong></li>
			<li style="width: 100%;">{{chat.mensaje}} </li>
			</ul>
			<div class="clearfix"></div>
			</div>
			 
        </div>
        <ng-template #noYoChat>
                <div class="chatbox__body__message chatbox__body__message--right">
		
                        <div class="chatbox_timing">
                        <ul>
                        <li><a href="#"><i class="fa fa-calendar"></i> {{chat.fecha}}</a></li>
                            <li><a href="#"><i class="fa fa-clock-o"></i> {{chat.hora}}</a></li>
                        </ul>
                        </div>
                    
                            <img src="{{chat.imagen}}" alt="Picture">
                            <div class="clearfix"></div>
                            <div class="ul_section_full">
                            <ul class="ul_msg">
                                    <li><strong>{{chat.emisor}}</strong></li>
                                    <li>{{chat.mensaje}} </li>
                            </ul>
                            <div class="clearfix"></div>
                            <ul class="ul_msg2">
                            <li><i *ngIf="chat.visto; else noVistoChat" class="mdi mdi-check-all visto">visto</i>
                                <ng-template #noVistoChat>
                                    <i class="mdi mdi-check"></i>
                                </ng-template></li>
                            </ul>
                            </div>
                             
                        </div>
        </ng-template>
        
        </div>
        
    </div>
    <div class="panel-footer">
                    <div class="input-group">
                        <form (ngSubmit)="chatModal()">
                        <input id="textChat" type="text" class="form-control input-sm chat_set_height" placeholder="escribe tu mensaje aqui..." tabindex="0" dir="ltr" spellcheck="false" autocomplete="off" autocorrect="off" autocapitalize="off" contenteditable="true" (click)="visto()" name="escribiendoChat" [(ngModel)]="escribiendoChat" (ngModelChange)="escribiendo()"/>
						
                        <span class="input-group-btn">
                            <button type="submit" class="btn bt_bg btn-sm" id="btn-chat">
                                Enviar</button>
                        </span>
                    </form>
                    </div>
                </div>
</div>
	    
	</div>
  </div>
  
  <!-- Sistema de chat -->
<div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Chat Sm8 (en implementacion)</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="panel-body">
                    <ul class="chat">
                        <div *ngFor="let chat of chatTarget">
                            <li *ngIf="chat.emisor !== usuario.userName; else noYoChat" class="left clearfix">
                                <span class="chat-img pull-left">
                                    <img src="http://placehold.it/50/55C1E7/fff&text={{chat.emisor}}" alt="User Avatar" class="img-circle" />
                                </span>
                                <div class="chat-body clearfix">
                                    <div class="header">
                                        <strong class="primary-font">{{chat.emisor}}</strong> <small class="pull-right text-muted">
                                    <span class="glyphicon glyphicon-time"></span>12 mins ago</small>
                                    </div>
                                    <p>
                                        {{chat.mensaje}}
                                    </p>
                                </div>
                            </li>
                            <ng-template #noYoChat>
                                <li class="right clearfix"><span class="chat-img pull-right">
                                    <img src="http://placehold.it/50/FA6F57/fff&text={{chat.emisor}}" alt="User Avatar" class="img-circle" />
                                </span>
                                    <div class="chat-body clearfix">
                                        <div class="header">
                                            <small class=" text-muted"><span class="glyphicon glyphicon-time"></span>13 mins ago</small>
                                            <strong class="pull-right primary-font">{{chat.emisor}}</strong>
                                        </div>
                                        <p>
                                            {{chat.mensaje}}
                                        </p>
                                    </div>
                                </li>
                            </ng-template>
                        </div>
                    </ul>
                </div>
            </div>
            <div class="modal-footer">
                <form (ngSubmit)="chatModal()">
                    <input id="textChat" type="text" />
                    <button type="submit" class="btn btn-info btn-circle btn-lg"><i class="fa fa-paper-plane-o"></i></button>
                </form>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_shared/top-bar/top-bar.component.html